import axios from 'axios'
import * as vars from './vars';

export function getUnreadMessageCount(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/admin/GetAdminUnreadMessageCount',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : {}
    })
}

export function getSupportChatThreads (jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/admin/GetAdminSupportChatThreads',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : {}
    })
}

export function getSupportChatThread (username, jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/admin/GetAdminSupportChatThread',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : {
            username: username
        }
    })
}

export function readSupportChatThread (username, jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/admin/ReadAdminSupportChatMessage',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : {
            username: username
        }
    })
}

export function sendSupportChatMessage (sendSupportChatMessageRequest, jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/admin/SendAdminSupportChatMessage',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : sendSupportChatMessageRequest
    })
}
